import { useCallback, useState } from 'react';

import type { BackError } from '../../../utils/back-errors.util';
import { userFriendlyErrors } from '../../../utils/back-errors.util';

import type { GenericAdminFormValues } from '../types/generic-admin-form-values.type';
import type { SubmitHandler } from '../types/submit-handler.type';

interface Params {
  readonly handleSubmit: SubmitHandler;
}

export const useGenericAdminSubmit = ({
  handleSubmit: pHandleSubmit,
}: Readonly<Params>) => {
  const [formError, setFormError] = useState<readonly string[] | null>(null);

  const handleSubmit = useCallback(
    (
      values: GenericAdminFormValues,
      {
        setSubmitting,
      }: Readonly<{ setSubmitting: (isSubmitting: boolean) => void }>,
    ) => {
      setFormError(null);

      const onSuccess = () => {
        setSubmitting(false);
      };

      const onError = (error: unknown) => {
        setFormError(userFriendlyErrors(error as BackError));
        setSubmitting(false);
      };

      pHandleSubmit(values, onError, onSuccess);
    },
    [pHandleSubmit],
  );

  return { formError, handleSubmit };
};
